export var ANALYTICS_DOMAIN = 'analytics';
export var SET_ANALYTICS_ENABLED = 'set_analytics_enabled';
export var SET_SUPER_PROPERTIES = 'set_super_properties';
export var ADD_SUPER_PROPERTIES = 'add_super_properties';
export var REMOVE_SUPER_PROPERTIES = 'remove_super_properties';
export var POST = 'post';
export var setAnalyticsEnabled = function (userId, isEnabled) { return ({
    domain: ANALYTICS_DOMAIN,
    eventType: SET_ANALYTICS_ENABLED,
    data: {
        is_enabled: isEnabled,
        user_id: userId,
    },
}); };
export var setSuperProperties = function (properties) { return ({
    domain: ANALYTICS_DOMAIN,
    eventType: SET_SUPER_PROPERTIES,
    data: {
        properties: properties,
    },
}); };
export var addSuperProperties = function (properties) { return ({
    domain: ANALYTICS_DOMAIN,
    eventType: ADD_SUPER_PROPERTIES,
    data: {
        properties: properties,
    },
}); };
export var removeSuperProperties = function (properties) { return ({
    domain: ANALYTICS_DOMAIN,
    eventType: REMOVE_SUPER_PROPERTIES,
    data: {
        properties: properties,
    },
}); };
export var post = function (name, properties) { return ({
    domain: ANALYTICS_DOMAIN,
    eventType: POST,
    data: {
        name: name,
        properties: properties,
    },
}); };
//# sourceMappingURL=analytics.js.map